import { ReactNode } from 'react';
import { Wrapper } from './CenterPageContent.styles';

const CenterPageContent = ({ children }: { children: ReactNode }) => (
  <Wrapper>{children}</Wrapper>
);

export { CenterPageContent };
